import { useMutation } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { queryClient } from '../../../queryClient';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';
import { TerminalButtonMedia } from '../../../types/Admin/TerminalAppearanceTypes';

export const usePostTerminalLogo = () => {
  const context = useContext(AlertContext);

  const { mutate: uploadTerminalLogo, isLoading: isUploadTerminalLogoLoading } = useMutation(
    ['TerminalAppearanceUploadLogo'],
    (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      return axios.post<TerminalButtonMedia>(
        TerminalAppearanceAPI.uploadLogo,
        formData,
        multipartHeaders()
      );
    },
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries('TerminalAppearance')
          .then(() =>
            context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage })
          );
      }
    }
  );

  return { uploadTerminalLogo, isUploadTerminalLogoLoading };
};
